import { observer } from "mobx-react-lite";
import { FC } from "react";

interface DebugIndexPageProps {}

export const DebugIndexPage: FC<DebugIndexPageProps> = observer(() => {
  return <div>Nothing here.</div>;
});
